import React, { memo } from 'react';
import { Text } from 'hoi-poi-ui-next';

const TitleContentDetail = memo(({ label }) => {
    if (!label) return null;
    return <Text type="h6">{label}</Text>;
});

export default TitleContentDetail;
